module.exports = __webpack_public_path__ + "static/media/discord1.96451abf.png";